import {
    FaChevronRight,
    FaCheck,
    FaTimes,
} from "react-icons/fa";

interface FilterMenuItemProps {
    label: string;
    value: string;
    open: boolean;
    onClick: () => void;
}

export const FilterMenuItem = ({
    label,
    value,
    open,
    onClick,
}: FilterMenuItemProps) => (
    <button
        type="button"
        onClick={onClick}
        className="flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-left transition hover:bg-gray-50"
    >
        <div>
            <p className="text-sm font-medium text-gray-700">
                {label}
            </p>

            <p className="text-xs text-gray-400">
                {value}
            </p>
        </div>

        {FaChevronRight({
            size: 12,
            className: `text-gray-400 transition-transform ${open ? "rotate-90" : ""
                }`,
        })}
    </button>
);


interface FilterOptionProps {
    label: string;
    active: boolean;
    onClick: () => void;
}

export const FilterOption = ({
    label,
    active,
    onClick,
}: FilterOptionProps) => (
    <button
        type="button"
        onClick={onClick}
        className={`flex w-full items-center justify-between rounded-lg px-3 py-2 text-left text-sm transition ${active
            ? "bg-indigo-50 font-medium text-indigo-600"
            : "text-gray-600 hover:bg-white"
            }`}
    >
        {label}

        {active &&
            FaCheck({
                size: 12,
            })}
    </button>
);


interface FilterChipProps {
    label: string;
    onRemove: () => void;
}

export const FilterChip = ({
    label,
    onRemove,
}: FilterChipProps) => (
    <span className="inline-flex max-w-[180px] items-center gap-1 rounded-lg bg-indigo-50 px-2.5 py-1 text-xs font-medium text-indigo-600">
        <span className="truncate">
            {label}
        </span>

        <button
            type="button"
            onClick={onRemove}
            className="shrink-0 rounded hover:bg-indigo-100"
        >
            {FaTimes({
                size: 10,
            })}
        </button>
    </span>
);


export const getDateLabel = (
    date: string,
    range = { from: "", to: "" }
) => {
    switch (date) {
        case "today":
            return "Today";

        case "yesterday":
            return "Yesterday";

        case "week":
            return "This Week";

        case "month":
            return "This Month";

        case "year":
            return "This Year";

        case "custom":
            if (range.from && range.to) {
                const from = new Date(`${range.from}T00:00:00`);
                const to = new Date(`${range.to}T00:00:00`);

                return `${from.toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                })} – ${to.toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                })}`;
            }

            return "Custom Range";

        default:
            return "Date";
    }
};
